import React, { FC } from 'react'

import loadable from '@loadable/component'

import { OperationSystem } from 'common-constants/bowser'
import { GQLForeignRootQuery } from 'components/page/ForeignProfile/gql/__generated__/ForeignRoot'
import { DefaultLoader } from 'components/presentational/AnimatedWatch/AnimatedWatch'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

import { CountriesCommon } from './CountriesCommon'

const CountriesWindowsLoadable = loadable(
  async () => (await import('./CountriesWindows')).CountriesWindows,
  {
    fallback: <DefaultLoader />,
  }
)

export type Countries = NonNullable<
  GQLForeignRootQuery['user']
>['travelAtlas']['visitedCountries']['visitedCountries']['nodes']

export const Countries: FC<{
  data: Countries
  currentUserData: NonNullable<
    GQLForeignRootQuery['my']
  >['travelAtlas']['visitedCountries']['visitedCountries']['nodes']
}> = ({ data, currentUserData }) => {
  const { osName } = useShallowEqualSelector(
    ({ systemReducer: { osName } }) => ({
      osName,
    })
  )

  const currentUserCountriesIds =
    currentUserData && currentUserData.length > 0
      ? currentUserData.map(({ country: { id } }) => id)
      : []

  if (data.length > 0) {
    if (osName === OperationSystem.Windows) {
      return (
        <CountriesWindowsLoadable
          countries={data}
          currentUserCountriesIds={currentUserCountriesIds}
        />
      )
    } else {
      return (
        <CountriesCommon
          countries={data}
          currentUserCountriesIds={currentUserCountriesIds}
        />
      )
    }
  }

  return null
}
